import { DesignConfigCategories } from 'src/modules/designStudio/constants/designConfig';

const LABEL_IDS = {
  GLASS_ID: 100,
  ENTRY_DOOR_ID: 102,
  PATIO_DOOR_ID: 104,
  SLIDING_GLASS_DOOR_ID: 105,
  BRICK_ID: 200,
  STONE_ID: 202,
  WOOD_ID: 205,
  VINYL_ID: 206,
  STUCCO_ID: 209,
  CONCRETE_ID: 211,
  TUDOR_ID: 220,
  WRAP_ID: 221,
  UNKNOWN_ID: 222,
  WHITE_ID: 301,
  SHUTTER_ID: 400,
  TRIM_ID: 401,
  FASCIA_ID: 402,
  SOFFIT_ID: 403,
  ROOF_ID: 404,
  SASH_ID: 405,
  DOOR_PACKAGE: 408,
  OPENINGS_TRIM_ID: 409,
  HORIZONTAL_SIDING_ID: 601,
  VERTICAL_SIDING_ID: 602,
  SHINGLED_SIDING_ID: 603,
  OTHER_SIDING_ID: 604,
};

const DesignConfigToLabelIdsMapping = {
  [DesignConfigCategories.WALL]: [
    LABEL_IDS.HORIZONTAL_SIDING_ID,
    LABEL_IDS.VERTICAL_SIDING_ID,
    LABEL_IDS.SHINGLED_SIDING_ID,
    LABEL_IDS.SHINGLED_SIDING_ID,
    LABEL_IDS.OTHER_SIDING_ID,
    LABEL_IDS.BRICK_ID,
    LABEL_IDS.STONE_ID,
    LABEL_IDS.STUCCO_ID,
    LABEL_IDS.CONCRETE_ID,
    LABEL_IDS.TUDOR_ID,
    LABEL_IDS.WRAP_ID,
    LABEL_IDS.UNKNOWN_ID,
  ],
  [DesignConfigCategories.ROOF]: [
    LABEL_IDS.ROOF_ID,
    LABEL_IDS.FASCIA_ID,
    LABEL_IDS.SOFFIT_ID,
  ],
  [DesignConfigCategories.TRIM]: [LABEL_IDS.TRIM_ID],
  [DesignConfigCategories.WINDOW]: [
    LABEL_IDS.GLASS_ID,
    LABEL_IDS.SASH_ID,
    LABEL_IDS.SHUTTER_ID,
  ],
};

const labelNames = {
  [LABEL_IDS.HORIZONTAL_SIDING_ID]: 'Horizontal Siding',
  [LABEL_IDS.VERTICAL_SIDING_ID]: 'Vertical Siding',
  [LABEL_IDS.SHINGLED_SIDING_ID]: 'Shingled Siding',
  [LABEL_IDS.OTHER_SIDING_ID]: 'Siding',
  [LABEL_IDS.BRICK_ID]: 'Brick',
  [LABEL_IDS.STONE_ID]: 'Stone',
  [LABEL_IDS.STUCCO_ID]: 'Stucco',
  [LABEL_IDS.CONCRETE_ID]: 'Concrete',
  [LABEL_IDS.TUDOR_ID]: 'Tudor',
  [LABEL_IDS.WRAP_ID]: 'Wrap',
  [LABEL_IDS.UNKNOWN_ID]: 'Unknown',
};

const getNameOfLabel = (label: number): string =>
  labelNames[label] ?? 'Unknown';

export { DesignConfigToLabelIdsMapping, getNameOfLabel, LABEL_IDS };
